import { Select } from 'antd'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { ENV_PRESETS } from '../config/envSwitcher'
import { useEnvStore } from '../stores/envStore'
import { useAuthStore } from '../stores/authStore'

export function EnvSwitcher() {
  const { apiBaseUrl, setApiBaseUrl } = useEnvStore()
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleChange = (newUrl: string) => {
    if (newUrl === apiBaseUrl) return
    setApiBaseUrl(newUrl)
    logout()
    queryClient.clear()
    navigate('/login')
  }

  return (
    <Select
      size="small"
      style={{ width: 130 }}
      value={apiBaseUrl}
      onChange={handleChange}
      options={ENV_PRESETS.map((p) => ({ label: p.label, value: p.apiBaseUrl }))}
    />
  )
}
